export default __webpack_public_path__ + "static/media/hybrid.ed542ebf.png";